import { Button, Col, Row, Tooltip } from "antd";
import { Link } from "react-router-dom";
import logo from "../../assets/images/Logo_white.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import styles from "./Footer.module.scss";
import { useTranslation } from "react-i18next";

import CopyToClipboard from "./CopyToClipboard";
import { useSize } from "ahooks";

export function Footer() {
  const projects = [
    { link: "Web Application", name: "Web applications" },
    { link: "ERP&type=CRM", name: "ERP/CRM" },
    { link: "ESG", name: "ESG" },
    { link: "UI/UX Design", name: "UI/UX Design" },
    { link: "E-commerce", name: "E-commerce" },
  ];
  const services = [
    { name: "Front-end development", type: "frontend" },
    { name: "Backend development", type: "backend" },
    { name: "User-centered design", type: "design" },
    { name: "App & Mobile", type: "web-applications" }
  ];
  const size = useSize(document.querySelector("body"));
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperChild}>
        <Row justify="space-between">
          <Col lg={10} md={13} sm={13} xs={24}>
            <Row justify="start">
              <Col span={24}>
                <Link to="/">
                  <div className={styles.logoBlock}>
                    <img
                      className={styles.logoImg}
                      src={logo}
                      alt="haltentech"
                    />
                    <span className={styles.logoText}>HaltenTech</span>
                  </div>
                </Link>
              </Col>
              <Col lg={8} md={10} xs={24} className={styles.menuBlock}>
                <h1 className={styles.menuTitle}>Projects</h1>
                {projects.map((v) => {
                  return (
                    <Link
                      to={{
                        pathname: "/portfolio/",
                        search: `?type=${v.link}`
                      }}
                    >
                      <div>
                        <h1 className={styles.menuList}>{v.name}</h1>
                      </div>
                    </Link>
                  );
                })}
              </Col>
              <Col lg={10} md={10} xs={24} className={styles.menuBlock}>
                <h1 className={styles.menuTitle}>Services</h1>
                {services.map((v) => {
                  return (
                    <Link
                      to={{
                        pathname: `/services/${v.type}`
                      }}
                    >
                      <div>
                        <h1 className={styles.menuList}>{v.name}</h1>
                      </div>
                    </Link>
                  );
                })}
              </Col>
            </Row>
          </Col>
          <Col lg={4} md={7} sm={7} xs={24} className={styles.subscribeBlock}>
            <Link to="/contacts">
              <Button className={styles.contactButton}>
                {t("contact.contactUs")}
              </Button>
            </Link>

            <Tooltip
              title={
                <Row align="middle">
                  <CopyToClipboard text="info@haltentech.com" />
                  <h1 className={styles.popoverText}>|</h1>
                  <a
                    className={styles.popoverButton}
                    href="mailto:info@haltentech.com"
                  >
                    Mail to
                  </a>
                </Row>
              }
              color="#FFF"
              trigger="hover"
            >
              <h1 className={styles.subscribeText}> info@haltentech.com</h1>
            </Tooltip>
            <Tooltip
              title={
                <Row align="middle">
                  <CopyToClipboard text="+4915125751285" />{" "}
                  <h1 className={styles.popoverText}>|</h1>
                  <a className={styles.popoverButton} href="tel:+4915125751285">
                    Call{" "}
                  </a>
                </Row>
              }
              trigger="hover"
              color="#FFF"
            >
              <h1 className={styles.subscribeText}> +49 1512 5751 285</h1>
            </Tooltip>

            <Link
              to="https://www.linkedin.com/company/haltentech-2018/"
              target="_blank"
            >
              {" "}
              <h1 className={styles.subscribeText}>
                LinkedIn{" "}
                <FontAwesomeIcon
                  icon={faLinkedinIn}
                  title="LinkedIn"
                  className={styles.subscribeImg}
                />
              </h1>
            </Link>
            <Link to="https://www.instagram.com/haltentech/" target="_blank">
              {" "}
              <h1 className={styles.subscribeText}>
                Instagram{" "}
                <FontAwesomeIcon
                  icon={faInstagram}
                  className={styles.subscribeImg}
                />
              </h1>
            </Link>
          </Col>
          {/* TODO: add Facebook account */}
        </Row>

        <Row className={styles.dotsBlock} justify="space-between">
          {Array.from(Array(size?.width! > 700 ? 7 : 4).keys()).map((v) => (
            <Col key={v}>
              <div className={styles.dot} />
            </Col>
          ))}
        </Row>
        {/* <Row justify="start">
          <Col>
            <a href="mailto: info@haltentech.com" className={styles.text}>
              Terms
            </a>
          </Col>
          <Col>
            <a href="mailto: info@haltentech.com" className={styles.text}>
              Privacy
            </a>
          </Col>
          <Col>
            <a href="mailto: info@haltentech.com" className={styles.text}>
              Cookies
            </a>
          </Col>
        </Row> */}
      </div>
    </div>
  );
}
